/**
 * EmergencySection.tsx
 * 緊急連絡先名, 続柄, 電話
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import FieldDisplay from '../shared/FieldDisplay';

const EMERGENCY_FIELDS = ['emergency_name', 'emergency_rel', 'emergency_tel'] as const;

export default function EmergencySection({
  data,
  onChange,
  disabled,
  onOpenEditMulti,
}: SectionProps) {
  const displayParts = [
    data.emergency_name,
    data.emergency_rel ? `(${data.emergency_rel})` : '',
    data.emergency_tel ? `- ${data.emergency_tel}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <SectionHeader title="緊急連絡先" />
      <FieldDisplay
        label="緊急連絡先"
        value={displayParts || null}
        fields={EMERGENCY_FIELDS}
        onClick={() =>
          onOpenEditMulti?.('緊急連絡先', [
            { field: 'emergency_name', label: '氏名', type: 'text' },
            { field: 'emergency_rel', label: '続柄', type: 'text' },
            { field: 'emergency_tel', label: '電話番号', type: 'tel' },
          ])
        }
      />
    </>
  );
}
